import { Link, Outlet } from "react-router";
import { ShoppingBag } from "lucide-react";
import { useCart } from "./store.ts";

// 鼠标移到「后台」上就开始下它的 chunk,点进去的时候多半已经到了
export default function App() {
  const count = useCart((s) => s.items.reduce((n, i) => n + i.qty, 0));
  return (
    <>
      <header className="top">
        <Link to="/" className="logo">木木家具</Link>
        <nav>
          <Link to="/">全部商品</Link>
          <Link to="/admin" onMouseEnter={() => import("./pages/Admin.tsx")}>后台</Link>
          <Link to="/cart" className="cart-link" aria-label="购物车">
            <ShoppingBag size={18} />
            {count > 0 && <span className="cart-count">{count}</span>}
          </Link>
        </nav>
      </header>
      <main className="page">
        <Outlet />
      </main>
      <footer className="foot">木木家具 · 一个用来学前端基建的示例商城</footer>
    </>
  );
}
